// Chapter titles from supabase/functions/pilnas-generation-worker/index.ts (CHAPTERS).
export const PILNAS_CHAPTER_TITLES = [
  "Tavo dabartinis taškas",
  "Kas tau šiuo metu svarbiausia",
  "Kur atsiranda įtampa",
  "Santykiai",
  "Darbas ir pinigai",
  "Energija ir laikas",
  "Ko nori toliau",
  "12 mėnesių kryptis",
  "90 dienų planas",
  "Tavo taisyklės",
  "Klausimai sau",
  "Laiškas sau po metų"
];
